import { Link } from "react-router-dom";

const features = [
  {
    icon: "ri-folder-3-line",
    title: "多类型资源库",
    desc: "热血、恋爱、奇幻、悬疑等十大题材持续收录，分类清晰，按需浏览。",
  },
  {
    icon: "ri-search-eye-line",
    title: "精准搜索与筛选",
    desc: "支持关键词检索，并可组合地区、年份与排序条件，快速定位目标作品。",
  },
  {
    icon: "ri-information-2-line",
    title: "清晰作品信息",
    desc: "作者、连载状态、地区、更新日期与简介一页看全，下载前更放心。",
  },
  {
    icon: "ri-download-2-line",
    title: "便捷下载入口",
    desc: "按卷列出 ZIP / PDF 格式与文件大小，下载操作直观清晰，一键直达。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full rounded-lg border border-background-200 bg-background-100 p-6 md:p-9">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-information-line" />
            关于本站
          </span>
          <h2 className="mt-4 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
            为离线阅读而生的漫画资源门户
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            禁漫天堂专注解决「在线观看前的下载需求」，把分散的漫画资源整理成清晰的分类、可搜索的目录与统一的下载入口。无论你是想收藏整套单行本，还是只想随手存几卷，都能在这里快速完成。
          </p>

          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {features.map((feature) => (
              <div key={feature.title} className="flex gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${feature.icon} text-lg`} />
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950">{feature.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <Link
            to="/about"
            className="mt-7 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            了解更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50" style={{ aspectRatio: "4 / 3" }}>
          <img
            src="https://readdy.ai/api/search-image?query=clean%20flat%20illustration%20of%20a%20manga%20reading%20desk%20with%20tablet%20showing%20comic%20panels%2C%20stacked%20graphic%20novels%2C%20warm%20orange%20and%20navy%20accents%2C%20minimal%20modern%20vector%20style%2C%20soft%20lighting&width=900&height=675&seq=jm-intro-illustration&orientation=landscape"
            alt="禁漫天堂漫画下载与离线阅读场景插画"
            title="禁漫天堂漫画下载平台特色"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}